import { render, staticRenderFns } from "./PgStorePage.vue?vue&type=template&id=9f978a00"
import script from "./PgStorePage.vue?vue&type=script&lang=js"
export * from "./PgStorePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports